import { Box, BuildingIcon, Card, CompanyAvatar, Flex, Heading, Paragraph, PinIcon, Status } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { getJobRequestClientInfo } from "@/data/job-requests";
import { JobRequestListDto } from "@/data/job-requests/types/JobRequest";
import { formatMultipleLocationsWithCounter } from "@/data/locations";
import { useFormats } from "@/hooks/Formats";
import { router } from "@/views/router";

interface DashboardJobsGridItemProps {
  item: JobRequestListDto;
}

export const DashboardJobsGridItem: FC<DashboardJobsGridItemProps> = ({ item }) => {
  const { t } = useTranslation("session");
  const { formatRate } = useFormats();

  const { name: clientName, logoPublicUrl } = getJobRequestClientInfo(item);

  return (
    <Card
      as={Link}
      to={
        router.get("job-requests.detail", {
          jobRequestId: item.id,
        }).path
      }>
      <Box as={Flex} pb="sm" pt="xs" alignItems="center">
        <Box pr="sm" alignSelf="center">
          <CompanyAvatar size="lg" img={logoPublicUrl} name={clientName} />
        </Box>
        <Box>
          <Heading size="h-xs" sx={{ overflowWrap: "anywhere" }}>
            {item.title}
          </Heading>
        </Box>
      </Box>

      <Flex as={Box} alignContent="center" pb="xxs">
        <Box alignSelf="center" pr="xs">
          <BuildingIcon size="xs" color="vg500" />{" "}
        </Box>
        <Box>
          <Paragraph color="n700" sx={{ overflowWrap: "anywhere" }}>
            {clientName}
          </Paragraph>
        </Box>
      </Flex>

      {Boolean(item.locations?.length) && (
        <Flex alignContent="center">
          <Box alignSelf="center" pr="xs">
            <PinIcon size="xs" color="vg500" />{" "}
          </Box>
          <Box>
            <Paragraph color="n700" sx={{ overflowWrap: "anywhere" }}>
              {formatMultipleLocationsWithCounter(t, item.locations)}
            </Paragraph>
          </Box>
        </Flex>
      )}
      <Flex>
        {!item.public && (
          <Box as={Flex} pt="sm" pr="sm">
            <Status variant="success">{t("JOB_REQUESTS.DETAIL.EXCLUSIVE")}</Status>
          </Box>
        )}
        {item.remoteness === 100 && (
          <Box as={Flex} pt="sm" pr="sm">
            <Status>{t("JOB_REQUESTS.DETAIL.REMOTENESS.REMOTE")}</Status>
          </Box>
        )}
        {item.rate && !!item.rate.maxRate && (
          <Box as={Flex} pt="sm" pr="sm">
            <Status>
              {formatRate(
                item.rate.maxRate,
                item.rate.currency,
                item.rate.clientRateType === "HOURLY" ? "h" : undefined,
              )}
            </Status>
          </Box>
        )}
      </Flex>
    </Card>
  );
};
